import { Select as BaseSelect } from "@base-ui/react/select";

import type { SelectGroupProps } from "./Select.types";

export function SelectGroup({ ...props }: SelectGroupProps) {
  return <BaseSelect.Group data-slot="select-group" {...props} />;
}
